import { createRoutine } from 'redux-saga-routines';

import { GET_USER_NOTIFICATIONS, UPDATE_NOTIFICATIONS } from './constants';

export const getUserNotificationsAction = createRoutine(GET_USER_NOTIFICATIONS);

export const updateNotificationsAction = createRoutine(UPDATE_NOTIFICATIONS);
